(function () {
  const originalFetch = window.fetch;
  let pendingGiftHandles = [];

  document.addEventListener('line-item:will-change', function (e) {
    if (e.detail.targetQuantity !== 0) return;
    const el = e.target;
    pendingGiftHandles = [el.dataset.regalo1Handle, el.dataset.regalo2Handle, el.dataset.regalo3Handle].filter(Boolean);
  });

  window.fetch = async function (url, options) {
    const urlStr = url instanceof Request ? url.url : String(url);

    if (urlStr.includes('cart/change.js') && options?.method === 'POST' && pendingGiftHandles.length) {
      const body = options.body ? JSON.parse(options.body) : {};

      if (body.quantity === 0) {
        const handlesToRemove = pendingGiftHandles.splice(0);
        const cart = await originalFetch('/cart.js').then((r) => r.json());

        for (const handle of handlesToRemove) {
          const giftItem = cart.items.find((i) => i.handle === handle);
          if (!giftItem) continue;
          await originalFetch(`${Shopify.routes.root}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: giftItem.key, quantity: 0 }),
          });
        }
      }
    }

    return originalFetch(url, options);
  };
})();

document.addEventListener('DOMContentLoaded', function () {
  const contactToggle = document.querySelector('.open-height-contact');

  if (contactToggle) {
    contactToggle.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelector('.buy-form-contact')?.classList.toggle('open');
    });
  }

  const utmSource = new URLSearchParams(window.location.search).get('utm_source');
  const phoneMap = {
    CILMDT: '900 037 182',
    CILMDG: '900 037 181',
    CILMDF: '900 037 180',
    CILMDY: '900 670 235',
  };
  const phone = phoneMap[utmSource];
  const phoneLi = document.querySelector('.header__secondary-nav li.phone');
  const anchor = phoneLi?.querySelector('a');
  if (utmSource && phoneMap[utmSource]) {
    const span = anchor?.querySelector('span');
    if (anchor) anchor.href = `tel:+34${phone.replace(/\s/g, '')}`;
    if (span) span.textContent = phone;
  }

  phoneLi.style.visibility = 'visible';
});
